var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaydonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 16 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path445",
    d: "M4.01778 24.5011L3.74386 24.9438L3.59736 25.0903H0.720087L0.700659 25.0709V0.622428L0.720084 0.603003H3.99835L4.01778 0.622425V23.9211V24.5011ZM11.9527 13.7962L11.9516 13.2187L12.3524 12.5709L12.5194 12.4152H15.2356L15.2703 12.4476L15.2989 29.3655L15.2651 29.397H12.0017L11.9818 29.3771L11.9527 13.7962Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.20601
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaydonIcon);
export default __webpack_public_path__ + "static/media/haydon-icon.1081c3ba633065fb7a1bfe4b4df5eab5.svg";
export { ForwardRef as ReactComponent };